import React from 'react';

export default class HotjarLogger extends React.Component {

    constructor(props) {
        super(props);
    }

    // This component has no state!
    shouldComponentUpdate() {
        return false;
    }

    componentDidMount() {
        const analyticsConfig = this.props.tenantConfig.analytics;
        if (!(analyticsConfig && analyticsConfig.hotjar && analyticsConfig.hotjar.enabled)) {
            // Disabled. Do nothing.
            return;
        }

        let self = this;

        if (window.addEventListener) {
            window.addEventListener('load', function () {
                self.enableHotjarLogging();
            }, false);
        }
        else if (window.attachEvent) {
            window.attachEvent('onload', function () {
                self.enableHotjarLogging();
            });
        }
    }

    enableHotjarLogging() {

        const analyticsConfig = this.props.tenantConfig.analytics;
        const hotjarSiteId = analyticsConfig.hotjar.hotjarSiteId;

        const html = `(function(h,o,t,j,a,r){
        h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
        h._hjSettings={hjid:${hotjarSiteId},hjsv:6};
        a=o.getElementsByTagName('head')[0];
        r=o.createElement('script');r.async=1;
        r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
        a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');`;

        setTimeout(function () {
            let script = document.createElement('script');
            script.type = 'text/javascript';
            script.text = html;

            document.body.appendChild(script);
        }, 40);
    }

    render() {
        return null;
    }
}
